<template>
    <div>
        <div class="section">
            <h1 class="title is-uppercase">{{ title }}</h1>
        </div>

        <div class="section" v-if="sended.message">
            <b-message type="is-success" has-icon>
                <p v-text="sended.message"></p>
            </b-message>
        </div>

        <div id="brand-form" class="section">
            <b-field :label="__('strings.brand.form.id')"
                     label-position="on-border">
                <b-input :placeholder="__('strings.brand.form.id')"
                         type="id" name="id"
                         v-model="input.brand.id" disabled></b-input>
            </b-field>

            <b-field :label="__('strings.brand.form.name')"
                     label-position="on-border">
                <b-input :placeholder="__('strings.brand.form.name')"
                         type="name" name="name"
                         v-model="input.brand.name" disabled></b-input>
            </b-field>

            <b-field :label="__('strings.brand.form.atelier_id')"
                     label-position="on-border">
                <b-input :placeholder="__('strings.brand.form.atelier_id')"
                         type="atelier_id" name="atelier_id"
                         v-model="input.brand.atelier_id" disabled></b-input>
            </b-field>

            <h3 class="subtitle mt-5 mb-4">Websites</h3>
            <b-switch class="mb-4" v-model="allWebsiteEnabled" @input="toggleAllWebsites">
                {{
                    allWebsiteEnabled ? __('strings.brand.form.disable_all_websites') :
                        __('strings.brand.form.enable_all_websites')
                }}
            </b-switch>
            <span>
                 <b-tooltip
                     :label="__('strings.brand.form.toggle_all_websites_info_tooltip')"
                     type="is-dark"
                     multilined>
                    <b-icon icon="alert-circle"></b-icon>
                </b-tooltip>
            </span>
            <b-tabs
                class="brand-websites-tabs"
                type="is-boxed"
                vertical
                :expanded="false">
                <b-tab-item v-for="(website, websiteIndex) in input.websites"
                            :key="website+'_' + websiteIndex"
                            :label="website.name">
                    <template #header>
                        <b-checkbox class="mr-3" v-model="website.enabled"></b-checkbox>
                        <p class="has-text-weight-bold"
                           v-bind:style="website.enabled? '' : 'text-decoration: line-through'">{{ website.name }}</p>
                    </template>
                    <h3 class="subtitle has-text-weight-bold mb-3">Retailers</h3>
                    <div
                        v-for="(multiplier, multiplierIndex) in website.multipliers"
                        :key="`multiplier_${multiplier.website_id}_${multiplierIndex}`">
                        <div class="columns mt-2">
                            <div class="column is-2">
                                {{ retailersMap.get(multiplier.retailer_id).name }}
                            </div>
                            <div class="column is-narrow">
                                <div>
                                    <p class="has-text-weight-bold mb-1">{{ __('strings.brand.form.company_recharge') }}</p>
                                    <b-field style="max-width:150px">
                                        <b-input
                                            type="number"
                                            step="any"
                                            min="0"
                                            name="company_recharge"
                                            v-model="website.multipliers[multiplierIndex].company_recharge"></b-input>
                                    </b-field>
                                </div>
                            </div>
                        </div>
                        <div class="is-divider mb-2"></div>
                    </div>
                </b-tab-item>
            </b-tabs>

            <div class="field">
                <b-button
                    tag="button"
                    type="is-primary"
                    class="is-uppercase"
                    :label="__('strings.form.submitEditButton')"
                    @click.prevent="submit"
                    rounded
                    outlined
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            input: {
                brand: {
                    id: null,
                    name: null,
                    atelier_id: "",
                },
                websites: [],
                multipliers: [],
                relationships: [],
                fixed_price_csvs: [],
            },
            sended: {
                message: ''
            },
            allWebsiteEnabled: false,
            item: null,
            retailers: [],
            retailersMap: new Map(),
            multipliersMap: new Map(),
        };
    },
    beforeMount() {
        axios.get('retailer/index?paginate=false')
            .then(response => {
                this.retailers = response.data;
                this.retailersMap = this.createMapByArrayWithId(this.retailers);
            })
            .catch(error => {
                this.retailers = [{id: 1, name: 'SamGP+FL'}, {id: 2, name: 'SamGG'}];
                this.retailersMap = this.createMapByArrayWithId(this.retailers);
            });
    },
    mounted() {
        if (this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey) {
            axios.get('/brand/edit/' + this.$route.params.routeKey)
                .then(response => {
                    this.item = response.data;
                    this.input.brand = response.data.brand;
                    response.data?.websites?.forEach(website => {
                        this.input.websites.push(website)
                    });
                    this.input.multipliers = response.data?.brand?.multipliers;
                    this.convertWebsitesData(response.data?.relationships);
                })
        }
    },
    methods: {
        submit() {

            /**
             *
             * @type {string}
             */

            let method = this.item ? 'patch' : 'post';
            let url = this.item ? `/update/brand/${this.$route.params.routeKey}` : '/store/brand';
            let formData = new FormData();

            for (let [websiteIndex, website] of this.input.websites.entries()) {
                formData.append(`websites[${websiteIndex}][website][id]`, website.id);
                formData.append(`websites[${websiteIndex}][website][enabled]`, website.enabled ? 1 : 0);
                for (let [multiplierIndex, multiplier] of website.multipliers.entries()) {
                    let companyRecharge = multiplier.company_recharge !== "null" ? multiplier.company_recharge : 0;
                    formData.append(`websites[${websiteIndex}][multipliers][${multiplierIndex}][retailer_id]`, multiplier.retailer_id);
                    formData.append(`websites[${websiteIndex}][multipliers][${multiplierIndex}][company_recharge]`, companyRecharge);
                    formData.append(`websites[${websiteIndex}][multipliers][${multiplierIndex}][fixed_price_csv][file]`, multiplier.fixed_price_csv);
                    formData.append(`websites[${websiteIndex}][multipliers][${multiplierIndex}][fixed_price_csv][name]`, multiplier.fixed_price_csv_name);
                }
            }
            formData.append('_method', method);
            axios.post(url, formData)
                .then(response => {
                    let translationKey = this.item ? 'messages.model.updated' : 'messages.model.created'
                    this.sended.message = this.__(translationKey, {name: this.__('strings.models.brand')})

                    console.log(this.sended);
                    if (!this.item) {
                        this.$router.push({
                            name: 'model.action',
                            params: {
                                resource: 'brand',
                                action: 'edit',
                                routeKey: response.data.id
                            }
                        });
                    }

                    this.item = Object.assign({}, response.data)
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                })
                .finally(() => {
                    window.scrollTo({top: 0, behavior: "smooth"});
                });
        },
        createMapByArrayWithId(array) {
            const map = new Map();
            array?.forEach(item => {
                map.set(item?.id, item);
            });
            return map;
        },
        convertWebsitesData(relationships) {
            const relMap = new Map();
            relationships?.forEach((relationship) => {
                relMap.set(relationship?.website_id, relationship);
            });
            const brandId = parseInt(this.$route.params.routeKey);
            this.input.websites?.forEach((website, websiteIndex) => {
                const isEnabled = relMap.get(website?.id)?.enabled;
                if (isEnabled !== undefined && isEnabled !== null) {
                    website.enabled = isEnabled === 1;
                } else {
                    website.enabled = true;
                }
                if (!website.multipliers) {
                    this.$set(this.input.websites[websiteIndex], 'multipliers', []);
                }
                if (website?.multipliers?.length < this.retailers.length) {
                    this.retailers.forEach(retailer => {
                        const retailerInMultipliers = this.input.multipliers?.find(multiplier => (multiplier.retailer_id === retailer.id && multiplier.website_id === website.id));
                        if (retailerInMultipliers === undefined) {
                            website.multipliers.push({
                                brand_id: brandId,
                                retailer_id: retailer.id,
                                website_id: website.id,
                                company_recharge: 0,
                                fixed_price_csv: null,
                            });
                        } else {
                            website.multipliers.push(retailerInMultipliers);
                        }
                    });
                }
            });
            this.allWebsiteEnabled = this.input.websites.map(website => website.enabled).every(toggle => toggle === true);
        },
        toggleAllWebsites(value) {
            this.input.websites.forEach(website => website.enabled = value);
        },
        handleOnClickUploadCsv(file, websiteIndex, multiplierIndex) {
            this.input.websites[websiteIndex].multipliers[multiplierIndex].fixed_price_csv = file;
            this.input.websites[websiteIndex].multipliers[multiplierIndex].fixed_price_csv_name = file?.name;
            this.$set(this.input.websites[websiteIndex], 'multipliers', this.input.websites[websiteIndex].multipliers);
        },
        deleteMultiplierFileByIndexes(websiteIndex, multiplierIndex) {
            this.input.websites[websiteIndex].multipliers[multiplierIndex].fixed_price_csv = null;
            this.$set(this.input.websites[websiteIndex], 'multipliers', this.input.websites[websiteIndex].multipliers);
        },
        deleteCsvFileByIndex(index) {
            this.input.fixed_price_csvs.splice(index, 1);
        }
    },
    computed: {
        title() {
            let translationKey = this.item ? 'strings.brand.form.editTitle' : 'strings.brand.form.title';
            return this.__(translationKey);
        }
    }
};
</script>
